<template>
  <ThemeSliderBig
    :top-title="mgnlPropsWithBtnColors.topTitle"
    :top-title-color="mgnlPropsWithBtnColors.topTitleColor"
    :sub-title-text="mgnlPropsWithBtnColors.subTitleText"
    :sub-title-text-color="mgnlPropsWithBtnColors.subTitleTextColor"
    :cta-text-color="mgnlPropsWithBtnColors.ctaTextColor"
    :cta-link="mgnlPropsWithBtnColors.ctaLink"
    :slides="mgnlPropsWithBtnColors.slides"
    :data-ab-id="mgnlProps?.dataABId"
  />
</template>

<script lang="ts" setup>
import { ThemeSliderBigBuilder, WrapperProps } from './ThemeSliderBig.model';
import ThemeSliderBig from './ThemeSliderBig.vue';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps(WrapperProps);

const { topTitleColor, subTitleTextColor, imageLoadType } = toRefs(props);
provide('imageLoadType', imageLoadType?.value ?? 'lazy');

const mgnlProps = {
  ...ThemeSliderBigBuilder.build(props),
  topTitleColor: magnoliaGetters.getHexColor(topTitleColor?.value),
  subTitleTextColor: magnoliaGetters.getHexColor(subTitleTextColor?.value),
};

magnoliaGetters.migratePageLinkToCtaLink(mgnlProps);

const mgnlPropsWithBtnColors = {
  ...mgnlProps,
  ctaTextColor: mgnlProps.ctaLink?.[0]?.ctaTextColor ? magnoliaGetters.getHexColor(mgnlProps.ctaLink?.[0]?.ctaTextColor) : '#ffffff',
  slides: mgnlProps?.slides?.map(slide => ({
    ...slide,
    titleColor: magnoliaGetters.getHexColor(slide.titleColor),
    subTitleColor: magnoliaGetters.getHexColor(slide.subTitleColor),
  })),
};
</script>
